import { computed, makeObservable } from "mobx";
import type { Api } from "../../core/apis";
import type { BaseModelData } from "../../core/BaseModel";
import { BaseModel } from "../../core/BaseModel";
import type { Stores } from "../../core/stores";
import type { BusinessTemplateScheduleItem } from "../admin/templates/BusinessTemplateModel";

export type BusinessScheduleItemSchedule = {
  uid: string; // Generated client side
  startTime: string; // Fasta eller localzied?
  endTime: string; // Fasta eller localzied?
  title: string;
};

export type BusinessScheduleItemData = BusinessTemplateScheduleItem &
  BaseModelData & {
    businessPlanUid: string;
  };

export class BusinessScheduleItem extends BaseModel<BusinessScheduleItemData> {
  constructor(stores: Stores, api: Api, data: BusinessScheduleItemData) {
    super(stores, api, data);

    Object.assign(this.data, {});

    makeObservable(this);
  }

  @computed get businessPlan() {
    return this.stores.businessPlansStore.byId.get(this.data.businessPlanUid);
  }

  @computed get calculatedDate(): string {
    if (this.data.offsetInDays !== null) {
      if (this.businessPlan?.data.eventInfo.date) {
        const updatedDateWithOffset = new Date(
          this.businessPlan.data.eventInfo.date.toDate(),
        );
        updatedDateWithOffset.setDate(
          updatedDateWithOffset.getDate() + (this.data?.offsetInDays || 0),
        );
        return updatedDateWithOffset.toISOString().split("T")[0];
      }
    }

    return this.data.date ?? new Date().toISOString().split("T")[0];
  }

  toFireStore(): Omit<BusinessScheduleItemData, "uid"> {
    return {
      ...this.fromBaseModel(),
      ...this.data,
    };
  }
}
